<div *ngIf="vm">
  <div class="progressCls"></div>
  <div *ngIf="vm.showProgressBar">
    <mat-progress-bar color="warn" mode="indeterminate"></mat-progress-bar>
  </div>

  <!-- Generator Container Start -->
  <div *ngIf="vm.queryParamsData?.assetType === 'Generator'" class="generator-container">
    <form #generatorForm="ngForm">
      <mat-tab-group [(selectedIndex)]="vm.generatorTabIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Generator Informations</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="assetId" placeholder="QR Code Asset Id" type="text" [(ngModel)]="vm.assetId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('assetId')" />
              <button
                class="search-button"
                mat-mini-fab
                matSuffix
                type="button"
                [attr.aria-label]="vm.scannerEnabled ? 'Close scanner' : 'Open scanner'"
                (click)="enableScanner()">
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
            </mat-form-field>

            <div *ngIf="vm.scannerEnabled" class="scanner-container">
              <zxing-scanner
                #scanner
                class="qr-reader"
                (scanSuccess)="scanSuccessHandler($event)">
              </zxing-scanner>
              <div #focusFrame *ngIf="vm.zoomFlag" class="focus-frame"></div>
              <div *ngIf="vm.zoomFlag" class="zoom-controls">
                <button aria-label="Zoom in" class="zoom-icon" type="button" (click)="zoomIn()">
                  <span aria-hidden="true" class="fa fa-search-plus"></span>
                </button>
                <button aria-label="Zoom out" class="zoom-icon" type="button" (click)="zoomOut()">
                  <span aria-hidden="true" class="fa fa-search-minus"></span>
                </button>
              </div>
            </div>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="localId" placeholder="Local ID" type="text" [(ngModel)]="vm.localId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('localId')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #statusCtrl="ngModel" name="status" placeholder="Status" required
                          [(ngModel)]="vm. selectedStatusObj" (selectionChange)="onStatusChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let status of vm.statuses; trackBy: trackByStatus" [value]="status">
                  {{ status.statusType }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="statusCtrl.invalid && statusCtrl.touched">Status is required</mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #serialNumberCtrl="ngModel" matInput name="serialNumber" placeholder="Serial Number" required
                     type="text" [(ngModel)]="vm.serialNumber"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('serialNumber')" />
              <mat-error *ngIf="serialNumberCtrl.invalid && serialNumberCtrl.touched">
                Serial Number is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #manufacturerCtrl="ngModel" name="manufacturer" placeholder="Manufacturer" required
                          [(ngModel)]="vm.selectedManufacturerObj" (selectionChange)="onManufacturerChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let manufacturer of vm.manufacturers; trackBy: trackByManufacturer"
                            [value]="manufacturer">
                  {{ manufacturer.manufacture }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="manufacturerCtrl.invalid && manufacturerCtrl.touched">
                Manufacturer is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #modelCtrl="ngModel" name="model" placeholder="Model" required
                          [(ngModel)]="vm.selectedModelObj" (selectionChange)="onModelChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let model of vm.models; trackBy: trackByModel" [value]="model">
                  {{ model.genModel }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="!vm.selectedManufacturerObj">Select Manufacturer first</mat-hint>
              <mat-hint *ngIf="vm.selectedManufacturerObj && !vm.models.length">No Models Found</mat-hint>
              <mat-error *ngIf="modelCtrl.invalid && modelCtrl.touched">
                Model is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #currentTypeCtrl="ngModel" name="currentType" placeholder="Current Type" required
                          [(ngModel)]="vm.selectedCurrentType">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let currentType of vm.currentTypes; trackBy: trackByCurrentType"
                            [value]="currentType?.currentType">
                  {{ currentType?.currentType }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="currentTypeCtrl.invalid && currentTypeCtrl.touched">
                Current Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #voltageCtrl="ngModel" name="outputVoltage" placeholder="Output Voltage" required
                          [(ngModel)]="vm.selectedVoltage">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let voltageType of vm.voltageTypes; trackBy: trackByVoltageType"
                            [value]="voltageType.voltage">
                  {{ voltageType.voltage }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="voltageCtrl.invalid && voltageCtrl.touched">
                Voltage Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #divisionCtrl="ngModel" name="division" placeholder="Division" required
                          [(ngModel)]="vm.selectedDivisionObj" (selectionChange)="onDivisionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let division of vm.divisions; trackBy: trackByDivision" [value]="division">
                  {{ division.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="divisionCtrl.invalid && divisionCtrl.touched">
                Division is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #regionCtrl="ngModel" name="region" placeholder="Region" required
                          [(ngModel)]="vm.selectedRegionObj" [disabled]="vm.isRegionsLoading"
                          (selectionChange)="onRegionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let region of vm.regions; trackBy: trackByRegion" [value]="region">
                  {{ region.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="regionCtrl.invalid && regionCtrl.touched">
                Region is required
              </mat-error>
              <mat-hint *ngIf="vm.isRegionsLoading || (!vm.isRegionsLoading && (!vm.regions?.length > 0 || !vm.regions))">
                Select a division first
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="ownerContact" placeholder="Owner & Contact" type="text"
                     [(ngModel)]="vm.ownerContact" (blur)="trimGeneratorLeadingAndTrailingSpaces('ownerContact')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #ownerTeamCtrl="ngModel" name="ownerTeam" placeholder="Owner Team" required
                          [(ngModel)]="vm.selectedTeam" [disabled]="vm.isTeamsLoading"
                          (selectionChange)="onTeamChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.teams; trackBy: trackByTeam" [value]="team">
                  {{team}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ownerTeamCtrl.invalid && ownerTeamCtrl.touched">
                Owner Team is required
              </mat-error>
              <mat-hint *ngIf="!vm.selectedRegion || 
                       (vm.selectedRegion && vm.isTeamsLoading) || 
                       (vm.selectedRegion && !vm.isTeamsLoading && (!vm.teams?.length > 0 || !vm.teams))">
                Select a region first
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="trailerId" placeholder="Trailer Name" [(ngModel)]="vm.selectedTrailer" [disabled]="vm.isTrailerLoading">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let trailer of vm.trailers; trackBy: trackByTrailerId" [value]="trailer.trailerId">
                  {{ trailer.trailerName ? trailer.trailerName : 'Anonymous Trailer' }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="!vm.selectedTeam">Select a Owner Team first</mat-hint>
              <mat-hint *ngIf="vm.selectedTeam && vm.isTrailerLoading">Loading Trailers...</mat-hint>
              <mat-hint *ngIf="vm.selectedTeam && !vm.isTrailerLoading && !vm.trailers.length">
                No Trailers Found
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="loanedToTeam" placeholder="Loaned To Team" [(ngModel)]="vm.selectedLoanedToTeam">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.loanedToTeams; trackBy: trackByTeam" [value]="team">
                  {{team}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="maintenance" placeholder="Maintenance" [(ngModel)]="vm.selectedMaintenance">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let maintenance of vm.maintenances; trackBy: trackByMaintenance"
                            [value]="maintenance.maintenance">
                  {{ maintenance.maintenance }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="generatorCord" placeholder="Generator Cord" type="text"
                     [(ngModel)]="vm.generatorCord" (blur)="trimGeneratorLeadingAndTrailingSpaces('generatorCord')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="generatorChain" placeholder="Generator Chain" type="text"
                     [(ngModel)]="vm.generatorChain" (blur)="trimGeneratorLeadingAndTrailingSpaces('generatorChain')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="generatorLock" placeholder="Generator Lock" type="text"
                     [(ngModel)]="vm.generatorLock" (blur)="trimGeneratorLeadingAndTrailingSpaces('generatorLock')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-label for="generatorComments">Comments</mat-label>
              <textarea id="generatorComments" matInput name="comments" rows="3" [(ngModel)]="vm.comments"
                        (blur)="trimGeneratorLeadingAndTrailingSpaces('comments')">
                  </textarea>
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Show Location</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="address" placeholder="Address" type="text" [(ngModel)]="vm.address"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('address')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="city" placeholder="City" type="text" [(ngModel)]="vm.city"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('city')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="state" placeholder="State" [(ngModel)]="vm.selectedState">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let state of vm.states; trackBy: trackByState" [value]="state.name">
                  {{ state.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput maxlength="5" minlength="5" name="zipcode" placeholder="Zip code" type="text"
                     [(ngModel)]="vm.zipcode" (blur)="trimGeneratorLeadingAndTrailingSpaces('zipcode')"
                     (keypress)="numberOnly($event)" (paste)="restrictPasteForText($event)" />
            </mat-form-field>

            <form *ngIf="vm.generatorLocationInfoForm" [formGroup]="vm.generatorLocationInfoForm">
              <mat-form-field class="mat-form-field-infix-class" style="margin-bottom:1%;">
                <input formControlName="currentGpsLatitude" matInput placeholder="Current Gps Latitude xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLatitude')"
                       (ngModelChange)="onChangeLocation(vm.generatorLocationInfoForm)">
                <mat-error *ngIf="vm.generatorLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateDecimal')">
                  Latitude <span class="text-type-bold">Must</span> Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.generatorLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateRange')">
                  {{ vm.generatorLocationInfoForm?.get('currentGpsLatitude')?.errors?.validateRange }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" style="margin-bottom:1%;">
                <input formControlName="currentGpsLongitude" matInput placeholder="Current Gps Longitude -xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLongitude')"
                       (ngModelChange)="onChangeLocation(vm.generatorLocationInfoForm)">
                <mat-error *ngIf="vm.generatorLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateDecimal')">
                  Longitude <span class="text-type-bold">Must</span> Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.generatorLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateRange')">
                  {{ vm.generatorLocationInfoForm?.get('currentGpsLongitude')?.errors?.validateRange }}
                </mat-error>
                <span class="macButton" matSuffix><span class="fa fa-mouse-pointer" matSuffix></span>
                  <a href="https://www.google.com/maps/search/?api=1&query={{vm.generatorLocationInfoForm?.value?.currentGpsLatitude}},{{vm.generatorLocationInfoForm?.value?.currentGpsLongitude}}"
                    target="_blank">Show on Map</a>
                </span>
              </mat-form-field>
            </form>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>

  <!-- Trailer Container Start -->
  <div *ngIf="vm.queryParamsData?.assetType === 'Trailer'" class="trailer-container">
    <form #trailerForm="ngForm">
      <mat-tab-group [(selectedIndex)]="vm.generatorTabIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Trailer Informations</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="assetId" placeholder="QR Code Asset Id" type="text" [(ngModel)]="vm.assetId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('assetId')" />
              <button
                class="search-button"
                mat-mini-fab
                matSuffix
                type="button"
                [attr.aria-label]="vm.trailerScannerEnabled ? 'Close scanner' : 'Open scanner'"
                (click)="enableTrailerScanner()">
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
            </mat-form-field>

            <div *ngIf="vm.trailerScannerEnabled" class="scanner-container">
              <zxing-scanner
                #trailerScanner
                class="qr-reader"
                (scanSuccess)="trailerScanSuccessHandler($event)">
              </zxing-scanner>
              <div #focusFrame *ngIf="vm.trailerZoomFlag" class="focus-frame"></div>
              <div *ngIf="vm.trailerZoomFlag" class="zoom-controls">
                <button aria-label="Zoom in" class="zoom-icon" type="button" (click)="trailerZoomIn()">
                  <span aria-hidden="true" class="fa fa-search-plus"></span>
                </button>
                <button aria-label="Zoom out" class="zoom-icon" type="button" (click)="trailerZoomOut()">
                  <span aria-hidden="true" class="fa fa-search-minus"></span>
                </button>
              </div>
            </div>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="localId" placeholder="Local ID" type="text" [(ngModel)]="vm.localId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('localId')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="serialNumber" placeholder="Serial Number" type="text" [(ngModel)]="vm.serialNumber"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('serialNumber')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #statusCtrl="ngModel" name="trailerStatus" placeholder="Status" required
                          [(ngModel)]="vm.selectedStatusObj" (selectionChange)="onStatusChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let status of vm.statuses; trackBy: trackByStatus" [value]="status">
                  {{ status.statusType }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="statusCtrl.invalid && statusCtrl.touched">
                Status is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="trailerName" placeholder="Trailer Name" type="text" [(ngModel)]="vm.trailerName"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerName')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #trailerSizeCtrl="ngModel" matInput name="trailerSize" placeholder="Trailer Size" required
                     type="text" [(ngModel)]="vm.trailerSize"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerSize')" />
              <mat-error *ngIf="trailerSizeCtrl.invalid && trailerSizeCtrl.touched">
                Trailer Size is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #trailerHeightCtrl="ngModel" matInput name="trailerHeight" placeholder="Trailer Height" required
                     type="text" [(ngModel)]="vm.trailerHeight"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerHeight')" />
              <mat-error *ngIf="trailerHeightCtrl.invalid && trailerHeightCtrl.touched">
                Trailer Height is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #divisionCtrl="ngModel" name="trailerDivision" placeholder="Division" required
                          [(ngModel)]="vm.selectedDivisionObj" (selectionChange)="onDivisionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let division of vm.divisions; trackBy: trackByDivision" [value]="division">
                  {{ division.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="divisionCtrl.invalid && divisionCtrl.touched">
                Division is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #regionCtrl="ngModel" name="trailerRegion" placeholder="Region" required
                          [(ngModel)]="vm.selectedRegionObj" [disabled]="vm.isRegionsLoading"
                          (selectionChange)="onRegionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let region of vm.regions; trackBy: trackByRegion" [value]="region">
                  {{ region.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="regionCtrl.invalid && regionCtrl.touched">Region is required</mat-error>
              <mat-hint *ngIf="vm.isRegionsLoading">Loading regions...</mat-hint>
              <mat-hint *ngIf="!vm.isRegionsLoading && !(vm.regions?.length > 0)">Select a division first</mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #ownerTeamCtrl="ngModel" name="trailerTeam" placeholder="Owner Team" required
                          [(ngModel)]="vm.selectedTeam" [disabled]="vm.isTeamsLoading">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.teams; trackBy: trackByTeam" [value]="team">
                  {{team}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ownerTeamCtrl.invalid && ownerTeamCtrl.touched">
                Team is required
              </mat-error>
              <mat-hint *ngIf="!vm.selectedRegion; else teamsLoadingOrEmpty">Select a region first</mat-hint>
              <ng-template #teamsLoadingOrEmpty>
                <mat-hint *ngIf="vm.isTeamsLoading; else noTeamsFound">Loading teams...</mat-hint>
              </ng-template>
              <ng-template #noTeamsFound>
                <mat-hint *ngIf="!(vm.teams?.length > 0)">No teams found</mat-hint>
              </ng-template>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="trailerLoanedToTeam" placeholder="Loaned To Team" [(ngModel)]="vm.selectedLoanedToTeam">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.loanedToTeams; trackBy: trackByTeam" [value]="team">
                  {{team}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #licensePlateCtrl="ngModel" matInput name="licensePlate" placeholder="License Plate" required
                     type="text" [(ngModel)]="vm.licensePlate"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('licensePlate')" />
              <mat-error *ngIf="licensePlateCtrl.invalid && licensePlateCtrl.touched">
                License Plate is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="generatorCapacity" placeholder="Generator Capacity" type="text"
                     [(ngModel)]="vm.generatorCapacity" (blur)="trimGeneratorLeadingAndTrailingSpaces('generatorCapacity')"
                     (keypress)="numberOnly($event)" (paste)="restrictPasteForText($event)" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #cdlRequiredCtrl="ngModel" name="cdlRequired" placeholder="CDL Required?" required
                          [(ngModel)]="vm.cdlRequired">
                <mat-option>--</mat-option>
                <mat-option [value]="1">Yes</mat-option>
                <mat-option [value]="0">No</mat-option>
              </mat-select>
              <mat-error *ngIf="cdlRequiredCtrl.invalid && cdlRequiredCtrl.touched">
                CDL Required? field is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="awayFromHome" placeholder="Away From Home?" [(ngModel)]="vm.awayFromHome">
                <mat-option>--</mat-option>
                <mat-option [value]="1">Yes</mat-option>
                <mat-option [value]="0">No</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #hitchSizeCtrl="ngModel" matInput name="hitchSize" placeholder="Hitch Size" required type="text"
                     [(ngModel)]="vm.hitchSize" (blur)="trimGeneratorLeadingAndTrailingSpaces('hitchSize')" />
              <mat-error *ngIf="hitchSizeCtrl.invalid && hitchSizeCtrl.touched">
                Hitch Size is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #hitchTypeCtrl="ngModel" matInput name="hitchType" placeholder="Hitch Type" required type="text"
                     [(ngModel)]="vm.hitchType" (blur)="trimGeneratorLeadingAndTrailingSpaces('hitchType')" />
              <mat-error *ngIf="hitchTypeCtrl.invalid && hitchTypeCtrl.touched">
                Hitch Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #primaryContactCtrl="ngModel" matInput name="primaryContact" placeholder="Primary Contact" required
                     type="text" [(ngModel)]="vm.primaryContact" (blur)="trimGeneratorLeadingAndTrailingSpaces('primaryContact')" />
              <mat-error *ngIf="primaryContactCtrl.invalid && primaryContactCtrl.touched">
                Primary Contact is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="secondaryContact" placeholder="Secondary Contact" type="text"
                     [(ngModel)]="vm.secondaryContact" (blur)="trimGeneratorLeadingAndTrailingSpaces('secondaryContact')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #lockTypeCtrl="ngModel" matInput name="lockType" placeholder="Lock Type" required type="text"
                     [(ngModel)]="vm.lockType" (blur)="trimGeneratorLeadingAndTrailingSpaces('lockType')" />
              <mat-error *ngIf="lockTypeCtrl.invalid && lockTypeCtrl.touched">
                Lock Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #lockCombinationCtrl="ngModel" matInput name="lockCombination" placeholder="Lock Combination"
                     required type="text" [(ngModel)]="vm.lockCombination"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('lockCombination')" />
              <mat-error *ngIf="lockCombinationCtrl.invalid && lockCombinationCtrl.touched">
                Lock Combination is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-label for="trailerComments">Comments</mat-label>
              <textarea id="trailerComments" matInput name="comments" rows="3" [(ngModel)]="vm.comments"
                        (blur)="trimGeneratorLeadingAndTrailingSpaces('comments')">
              </textarea>
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Show Location</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input #houseNumberInputCtrl="ngModel" matInput name="houseNumberInput" placeholder="House Number"
                     required type="text" [(ngModel)]="vm.houseNumberInput"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('houseNumberInput')">
              <mat-error *ngIf="houseNumberInputCtrl.invalid && houseNumberInputCtrl.touched">
                House Number is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #streetCtrl="ngModel" matInput name="street" placeholder="Street" required [(ngModel)]="vm.street"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('street')">
              <mat-error *ngIf="streetCtrl.invalid && streetCtrl.touched">
                Street is required
              </mat-error>
              <span class="macButton" matSuffix><span class="fa fa-mouse-pointer" matSuffix></span>
                <a href="https://www.google.com/maps/place/{{vm.houseNumberInput}}+{{vm.street}}+{{vm.city}}+{{vm.selectedState}}+{{vm.zip}}"
                   target='_blank'>Show on Map</a>
              </span>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #cityCtrl="ngModel" matInput name="city" placeholder="City" required [(ngModel)]="vm.city"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('city')">
              <mat-error *ngIf="cityCtrl.invalid && cityCtrl.touched">
                City is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #stateCtrl="ngModel" name="state" placeholder="State" required [(ngModel)]="vm.selectedState">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let state of vm.states; trackBy: trackByState" [value]="state.name">
                  {{ state.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="stateCtrl.invalid && stateCtrl.touched">
                State is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #zipCtrl="ngModel" matInput maxlength="5" minlength="5" name="zip" placeholder="Zip Code" required
                     [(ngModel)]="vm.zip" (blur)="trimGeneratorLeadingAndTrailingSpaces('zip')"
                     (keypress)="numberOnly($event)" (paste)="restrictPasteForText($event)">
              <mat-error *ngIf="zipCtrl.invalid && zipCtrl.touched">
                Zip is required and must be 5 digits
              </mat-error>
            </mat-form-field>

            <form *ngIf="vm.trailerLocationInfoForm" [formGroup]="vm.trailerLocationInfoForm">
              <mat-form-field class="mat-form-field-infix-class" style="margin-bottom:1%;">
                <input formControlName="currentGpsLatitude" matInput placeholder="Current Gps Latitude xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLatitude')"
                       (ngModelChange)="onChangeLocation(vm.trailerLocationInfoForm)">
                <mat-error *ngIf="vm.trailerLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateDecimal')">
                  Latitude <span class="text-type-bold">Must</span> Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.trailerLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateRange')">
                  {{ vm.trailerLocationInfoForm?.get('currentGpsLatitude')?.errors?.validateRange }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" style="margin-bottom:1%;">
                <input formControlName="currentGpsLongitude" matInput placeholder="Current Gps Longitude -xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLongitude')"
                       (ngModelChange)="onChangeLocation(vm.trailerLocationInfoForm)">
                <mat-error *ngIf="vm.trailerLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateDecimal')">
                  Longitude <span class="text-type-bold">Must</span> Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.trailerLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateRange')">
                  {{ vm.trailerLocationInfoForm?.get('currentGpsLongitude')?.errors?.validateRange }}
                </mat-error>
                <span class="macButton" matSuffix><span class="fa fa-mouse-pointer" matSuffix></span>
                  <a href="https://www.google.com/maps/search/?api=1&query={{vm.trailerLocationInfoForm?.value?.currentGpsLatitude}},{{vm.trailerLocationInfoForm?.value?.currentGpsLongitude}}"
                     target="_blank">Show on Map</a>
                </span>
              </mat-form-field>
            </form>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>

  <!-- Fuel Tank Container Start -->
  <div *ngIf="vm.queryParamsData?.assetType === 'Fuel Tank'" class="fuel-tank-container">
    <form #fuelTankForm="ngForm">
      <mat-tab-group [(selectedIndex)]="vm.generatorTabIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Fuel Tank Informations</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankAssetId" placeholder="QR Code Asset Id" type="text"
                     [(ngModel)]="vm.fuelTankAssetId" (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankAssetId')" />
              <button
                class="search-button"
                mat-mini-fab
                matSuffix
                type="button"
                [attr.aria-label]="vm.fuelTankScannerEnabled ? 'Close scanner' : 'Open scanner'"
                (click)="enableFuelTankScanner()">
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
            </mat-form-field>

            <div *ngIf="vm.fuelTankScannerEnabled" class="scanner-container">
              <zxing-scanner
                #fuelTankScanner
                class="qr-reader"
                (scanSuccess)="fuelTankScanSuccessHandler($event)">
              </zxing-scanner>
              <div #focusFrame *ngIf="vm.fuelTankZoomFlag" class="focus-frame"></div>
              <div *ngIf="vm.fuelTankZoomFlag" class="zoom-controls">
                <button aria-label="Zoom in" class="zoom-icon" type="button" (click)="fuelTankZoomIn()">
                  <span aria-hidden="true" class="fa fa-search-plus"></span>
                </button>
                <button aria-label="Zoom out" class="zoom-icon" type="button" (click)="fuelTankZoomOut()">
                  <span aria-hidden="true" class="fa fa-search-minus"></span>
                </button>
              </div>
            </div>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankLocalId" placeholder="Local ID" type="text" [(ngModel)]="vm.fuelTankLocalId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankLocalId')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankSerialNumber" placeholder="Serial Number" type="text"
                     [(ngModel)]="vm.fuelTankSerialNumber"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankSerialNumber')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #statusCtrl="ngModel" name="fuelTankStatus" placeholder="Status" required
                          [(ngModel)]="vm.selectedStatusObj" (selectionChange)="onStatusChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let status of vm.statuses; trackBy: trackByStatus" [value]="status">
                  {{ status.statusType }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="statusCtrl.invalid && statusCtrl.touched">
                Status is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #divisionCtrl="ngModel" name="fuelTankDivision" placeholder="Division" required
                          [(ngModel)]="vm.selectedDivisionObj" (selectionChange)="onDivisionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let division of vm.divisions; trackBy: trackByDivision" [value]="division">
                  {{ division.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="divisionCtrl.invalid && divisionCtrl.touched">
                Division is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #regionCtrl="ngModel" name="fuelTankRegion" placeholder="Region" required
                          [(ngModel)]="vm.selectedRegionObj" [disabled]="vm.isRegionsLoading"
                          (selectionChange)="onRegionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let region of vm.regions; trackBy: trackByRegion" [value]="region">
                  {{ region.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="regionCtrl.invalid && regionCtrl.touched">
                Region is required
              </mat-error>
              <mat-hint *ngIf="vm.isRegionsLoading">Loading regions...</mat-hint>
              <mat-hint *ngIf="!vm.isRegionsLoading && !(vm.regions?.length > 0)">Select a division first</mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #ownerTeamCtrl="ngModel" name="fuelTankTeam" placeholder="Owner Team" required
                          [(ngModel)]="vm.selectedTeam" [disabled]="vm.isTeamsLoading"
                          (selectionChange)="onTeamChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.teams; trackBy: trackByTeam" [value]="team">
                  {{team}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ownerTeamCtrl.invalid && ownerTeamCtrl.touched">
                Team is required
              </mat-error>
              <mat-hint *ngIf="!vm.selectedRegion; else teamsLoadingOrEmptyFuel">Select a region first</mat-hint>
              <ng-template #teamsLoadingOrEmptyFuel>
                <mat-hint *ngIf="vm.isTeamsLoading; else noTeamsFoundFuel">Loading teams...</mat-hint>
              </ng-template>
              <ng-template #noTeamsFoundFuel>
                <mat-hint *ngIf="!(vm.teams?.length > 0)">No teams found</mat-hint>
              </ng-template>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="trailerIdFuelTank" placeholder="Trailer Name" [(ngModel)]="vm.selectedTrailerObj"
                          [disabled]="vm.isTrailerLoading" (selectionChange)="onTrailerChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let trailer of vm.trailers; trackBy: trackByTrailerId" [value]="trailer">
                  {{ trailer.trailerName ? trailer.trailerName : 'Anonymous Trailer' }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="!vm.selectedTeam">Select an Owner Team first</mat-hint>
              <mat-hint *ngIf="vm.selectedTeam && vm.isTrailerLoading">Loading Trailers...</mat-hint>
              <mat-hint *ngIf="vm.selectedTeam && !vm.isTrailerLoading && !vm.trailers.length">No Trailers Found</mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="fuelTankLoanedToTeam" placeholder="Loaned To Team"
                          [(ngModel)]="vm.fuelTankLoanedToTeam">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.loanedToTeams; trackBy: trackByTeam" [value]="team">
                  {{team}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #fuelTankCapacityCtrl="ngModel" name="fuelTankCapacity" placeholder="Capacity (Gallons)"
                          required [(ngModel)]="vm.fuelTankCapacity">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let fuelTankSize of vm.fuelTankSizes; trackBy: trackByFuelTankSize"
                            [value]="fuelTankSize.fuelTankSize">
                  {{ fuelTankSize.fuelTankSize }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="fuelTankCapacityCtrl.invalid && fuelTankCapacityCtrl.touched">
                Fuel Tank Capacity is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-label for="fuelTankComments">Comments</mat-label>
              <textarea id="fuelTankComments" matInput name="fuelTankComments" rows="3" [(ngModel)]="vm.fuelTankComments"
                        (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankComments')">
              </textarea>
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Show Location</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankAddress" placeholder="Address" type="text" [(ngModel)]="vm.address"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('address')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankCity" placeholder="City" type="text" [(ngModel)]="vm.city"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('city')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="fuelTankState" placeholder="State" [(ngModel)]="vm.selectedState">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let state of vm.states; trackBy: trackByState" [value]="state.name">
                  {{ state.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput maxlength="5" minlength="5" name="fuelTankZipcode" placeholder="Zip Code" type="text"
                     [(ngModel)]="vm.zipcode" (blur)="trimGeneratorLeadingAndTrailingSpaces('zipcode')"
                     (keypress)="numberOnly($event)" (paste)="restrictPasteForText($event)" />
            </mat-form-field>

            <form *ngIf="vm.fuelTankLocationInfoForm" [formGroup]="vm.fuelTankLocationInfoForm">
              <mat-form-field class="mat-form-field-infix-class" style="margin-bottom:1%;">
                <input formControlName="currentGpsLatitude" matInput placeholder="Current Gps Latitude xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLatitude')"
                       (ngModelChange)="onChangeLocation(vm.fuelTankLocationInfoForm)">
                <mat-error *ngIf="vm.fuelTankLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateDecimal')">
                  Latitude <span class="text-type-bold">Must</span> Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.fuelTankLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateRange')">
                  {{ vm.fuelTankLocationInfoForm?.get('currentGpsLatitude')?.errors?.validateRange }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-infix-class" style="margin-bottom:1%;">
                <input formControlName="currentGpsLongitude" matInput placeholder="Current Gps Longitude -xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLongitude')"
                       (ngModelChange)="onChangeLocation(vm.fuelTankLocationInfoForm)">
                <mat-error *ngIf="vm.fuelTankLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateDecimal')">
                  Longitude <span class="text-type-bold">Must</span> Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.fuelTankLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateRange')">
                  {{ vm.fuelTankLocationInfoForm?.get('currentGpsLongitude')?.errors?.validateRange }}
                </mat-error>
                <span class="macButton" matSuffix><span class="fa fa-mouse-pointer" matSuffix></span>
                  <a href="https://www.google.com/maps/search/?api=1&query={{vm.fuelTankLocationInfoForm?.value?.currentGpsLatitude}},{{vm.fuelTankLocationInfoForm?.value?.currentGpsLongitude}}"
                     target="_blank">Show on Map</a>
                </span>
              </mat-form-field>
            </form>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>
</div>